(function () {
  'use strict';

  if (!document.querySelector('[data-template="collection"]')) return;

  document.documentElement.classList.add('anim-ready');

  var cards = document.querySelectorAll(
    '[data-template="collection"] .product-grid__item'
  );

  if ('IntersectionObserver' in window) {
    var cardIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el instanceof HTMLElement) {
          var parent = el.parentNode;
          var idx = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
          var rowOffset = (idx % 2) * 120;
          el.style.transitionDelay = rowOffset + 'ms';
          el.classList.add('is-in-view');
          cardIO.unobserve(el);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    cards.forEach(function (c) { cardIO.observe(c); });
  } else {
    cards.forEach(function (c) { c.classList.add('is-in-view'); });
  }

  if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    cards.forEach(function (cardElRaw) {
      if (!(cardElRaw instanceof HTMLElement)) return;
      var card = cardElRaw;
      /** @type {number | null} */
      var raf = null;
      var lastX = 0;
      var lastY = 0;

      var update = function () {
        raf = null;
        var rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = ((lastX - rect.left) / rect.width) * 100;
        var y = ((lastY - rect.top) / rect.height) * 100;
        card.style.setProperty('--spot-x', x.toFixed(2) + '%');
        card.style.setProperty('--spot-y', y.toFixed(2) + '%');
      };

      card.addEventListener('mouseenter', function () {
        card.classList.add('is-hover');
      });
      card.addEventListener('mousemove', function (e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (raf === null) raf = requestAnimationFrame(update);

        // Hover-based parallax
        var rect = card.getBoundingClientRect();
        var cardCenterX = rect.left + rect.width / 2;
        var cardCenterY = rect.top + rect.height / 2;

        // Calculate mouse position relative to card center (-1 to 1)
        var mouseXRelative = (e.clientX - cardCenterX) / (rect.width / 2);
        var mouseYRelative = (e.clientY - cardCenterY) / (rect.height / 2);

        // Find image and text elements
        var gallery = card.querySelector('.card-gallery');
        var info = card.querySelector('.group-block');

        if (gallery && info) {
          // Image moves opposite to mouse (parallax depth effect)
          var imageOffsetX = -mouseXRelative * 12;
          var imageOffsetY = -mouseYRelative * 12;

          // Text moves slightly with mouse (foreground layer)
          var textOffsetX = mouseXRelative * 5;
          var textOffsetY = mouseYRelative * 5;

          gallery.style.transform = 'translate(' + imageOffsetX + 'px, ' + imageOffsetY + 'px)';
          info.style.transform = 'translate(' + textOffsetX + 'px, ' + textOffsetY + 'px)';
        }
      }, { passive: true });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-hover');

        // Reset parallax transforms
        var gallery = card.querySelector('.card-gallery');
        var info = card.querySelector('.group-block');
        if (gallery) gallery.style.transform = 'translate(0, 0)';
        if (info) info.style.transform = 'translate(0, 0)';
      });
    });
  }
})();
